import { defineStore } from 'pinia'
import axios from 'axios'
import { indexes, filterData } from '@/util/helpers'

export const useRepositoryStore = defineStore('repository', {
  state: () => ({ 
    allRepositories: {
      items: [],
    },
    repository: {},
    loading: false,
    query: '',
  }),
  actions: {
    async loadRepositories (parent) {        
        this.loading = true
        const req = await axios.get(`/api/repositories/${parent}`)
        this.allRepositories = req.data
        this.loading = false
    },
    async saveRepositories (parent, data) {
        this.loading = true
        const idxs = indexes(this.allRepositories.items, this.query)
        this.allRepositories.items = 
            this.allRepositories.items.filter((_, i) => !idxs.includes(i))
                .concat(data.items)

        this.allRepositories.parent = 'multiverse'

        this.allRepositories.parent = parent
        await axios.post('/api/repositories/', this.allRepositories)
        this.loading = false
    },  
  },
  getters: {
    repositories () {
      return {
        items: filterData(this.allRepositories.items, this.query),
      }
    },
  },
})
